import React, { useState, useContext, useEffect, useRef } from 'react';
import { Card } from 'react-bootstrap';
import DealContext from '../DealContext';

const DealNameCard = () => {
  const [editName, setEditName] = useState(false);
  const editNameRef = useRef(null);

  const { deal, updateName } = useContext(DealContext);

  const [name, setName] = useState(deal.name || '');

  useEffect(() => {
    if (editName) {
      setTimeout(() => {
        if (editNameRef.current) {
          editNameRef.current.select();
        }
      }, 10);
    }
  }, [editName]);

  return (
    <Card>
      <div className="card-toolbar">
        {editName === true ? (
          <>
            <div
              className="card-toolbar-button"
              title="Accept"
              onClick={() => updateName(name).then(() => setEditName(false))}
            >
              <i style={{ color: 'var(--green-5)' }} className="fas fa-check fa-fw" />
            </div>
            <div className="card-toolbar-button" title="Cancel" onClick={() => setEditName(false)}>
              <i style={{ color: 'var(--red-5)' }} className="fas fa-times fa-fw" />
            </div>
          </>
        ) : (
          <div className="card-toolbar-button" onClick={() => setEditName(true)}>
            <i className="fas fa-pen fa-fw" />
          </div>
        )}
      </div>
      <Card.Body>
        <Card.Title>Name</Card.Title>
        {editName === true ? (
          <input
            className="form-control"
            value={name}
            onChange={e => setName(e.target.value)}
            ref={editNameRef}
            maxLength="50"
          />
        ) : (
          <Card.Text onDoubleClick={() => setEditName(true)}>{deal.name || 'No Name Set'}</Card.Text>
        )}
      </Card.Body>
    </Card>
  );
};

export default DealNameCard;
